import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  leftIcon?: React.ReactNode;
}
export function Input({
  label,
  error,
  helperText,
  leftIcon,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-104">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-105">
          {label}
        </label>}
      <div className="relative rounded-md shadow-sm" data-id="element-106">
        {leftIcon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500" data-id="element-107">
            {leftIcon}
          </div>}
        <input className={`block w-full rounded-md border-gray-300 focus:border-bulog-blue focus:ring-bulog-blue sm:text-sm py-2 px-3 border ${leftIcon ? 'pl-10' : ''} ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-108" />
      </div>
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-109">{error}</p>}
      {helperText && !error && <p className="mt-1 text-sm text-gray-500" data-id="element-110">{helperText}</p>}
    </div>;
}